var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"establishments-main"}},[_c('div',{staticClass:"horizontal-fixed-menu"},[_c('navigation',{attrs:{"options":_vm.options}})],1),_c('div',{staticClass:"fixed-content"},[_c('router-view',{attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }